import {ProjectSystemType} from "../model2/project/types"

// Loads data that isn't part of the initial session payload (i.e. tags) - but may already
// be present if it was included in the initial session reset, so that is checked first.
// Multiple callers requesting the same data while it's loading receive the same pending promise.
export default class GDSessionLoader {

    private _tagsLoaded    : boolean = false

    private _tagsPromise?  : Promise<void>

    get tagsLoaded():boolean {
        if (!this._tagsLoaded && this._tagsInSession()) {
            this._tagsLoaded = true
        }

        return this._tagsLoaded
    }

    private _tagsInSession():boolean {
        const tagsCollection = gd.session.projects.filterByCompany(gd.companyId).filterBySystemType(ProjectSystemType.TAG)
        return tagsCollection.models.length > 0
    }

    async loadTags(): Promise<void> {
        if (this.tagsLoaded) {
            return
        }

        if (!this._tagsPromise) {
            this._tagsPromise = this._loadTags()
        }

        return this._tagsPromise
    }

    private async _loadTags(): Promise<void> {
        try {
            await gd.api.Session.getMissingData({ rootTags: true }).promise()
            this._tagsLoaded = true
        } catch (error: any) {
            this._tagsPromise = undefined
            throw error
        }
    }

    /*** WEBHOOKS (v2) ***/

    private _webhooksPromise? : Promise<void>

    // Callers go through gd.session.getWebhooks() / reloadWebhooks().
    async loadWebhooks(force: boolean = false): Promise<void> {

        if (gd.session.webhooksLoaded && !force) {
            return
        }

        // A picker renders before its first answer arrives and asks again —
        // without sharing the pending promise one opened form issues a burst
        // of identical requests.
        if (!this._webhooksPromise || force) {
            this._webhooksPromise = this._loadWebhooks()
        }

        return this._webhooksPromise
    }

    // The answer arrives as the server's webhook reset event, so the session is
    // filled by SessionEvent_WebhookReset - nothing is written from here.
    private async _loadWebhooks(): Promise<void> {
        try {
            await gd.api.Session.getMissingData({ webhooksReset: true }).promise()

        } catch (error: any) {
            // Not rethrown: callers render whatever the session holds, and a
            // picker that retries on every render would loop the request.
            console.error("Session: webhooks error", error)
            this._webhooksPromise = undefined
        }
    }

}
